/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { DemandLetterRequest, DemandLetterResponse, HTTPValidationError } from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class DemandLetter<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * @description Genera cartas de reclamación formales según el ordenamiento jurídico colombiano, incluyendo requisitos legales específicos y cumplimiento normativo.
   *
   * @tags demands
   * @name DraftDemandLetterEndpointDemandLetterGeneratePost
   * @summary Generación de Carta de Reclamación
   * @request POST:/demand-letter/generate
   */
  draftDemandLetterEndpointDemandLetterGeneratePost = (data: DemandLetterRequest, params: RequestParams = {}) =>
    this.request<DemandLetterResponse, HTTPValidationError>({
      path: `/demand-letter/generate`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Obtiene las plantillas de cartas de reclamación disponibles
   *
   * @tags demands
   * @name GetDemandLetterTemplatesDemandLetterTemplatesGet
   * @summary Plantillas Disponibles
   * @request GET:/demand-letter/templates
   */
  getDemandLetterTemplatesDemandLetterTemplatesGet = (params: RequestParams = {}) =>
    this.request<Record<string, string[]>, any>({
      path: `/demand-letter/templates`,
      method: "GET",
      format: "json",
      ...params,
    });
}
